import React from 'react';
import { Button } from 'mypages-library';
import { useTranslation } from 'react-i18next';
import congratulation from 'images/wbaccount/congratulations.png';
import { navigateToLogin } from 'common/navigationUtil';
import { useInitialize } from 'common/hooks/useInitialize';
import styles from 'common/PageTemplate/PageTemplate.module.scss';
import PageTemplate from 'common/PageTemplate/PageTemplate';

const ConfirmNewEmailSuccess = () => {
  const { t } = useTranslation();
  useInitialize();
  return (
    <PageTemplate dataTestId="confirm-new-email-success">
      <h1 className={styles.title}>{t('MPL_CONFIRM_NEW_EMAIL_TITLE')}</h1>
      <p className={styles.text}>{t('MPL_CONFIRM_NEW_EMAIL_DESCRIPTION')}</p>
      <div className={styles.imageContainer}>
        <img src={congratulation} className={styles.webAccountImage} alt="Email confirmed" />
      </div>
      <Button
        text={t('MPL_CREATE_ACCOUNT_VERIFY_LOG_IN')}
        primary
        onClick={navigateToLogin}
        className={styles.confirmButton}
        dataTestId="newEmailConfirmedBtn"
      />
    </PageTemplate>
  );
};

export default ConfirmNewEmailSuccess;
